module.exports = __webpack_public_path__ + "static/media/entregarinju3.6378aed9.webp";